import Sefer from './Sefer/Sefer';
import BeitMidrash from './BeitMidrash/BeitMidrash';
import Royal from './Royal/Royal';
import Tiles from './Tiles/Tiles';
import Ledger from './Ledger/Ledger';
import Scroll from './Scroll/Scroll';
import Columns from './Columns/Columns';

export default { Sefer, BeitMidrash, Royal, Tiles, Ledger, Scroll, Columns };
